import type { ElementType, ReactNode } from 'react';
import {
  Card,
  CardActionArea,
  Stack,
  type SxProps,
  type Theme,
} from '@mui/material';
import { useNavigate } from 'react-router';

export type InfoCardProps = {
  icon: ElementType;
  children: ReactNode;
  className?: string;
  withBorder?: boolean;
  onClick?: () => void;
  sx?: SxProps<Theme>;
  iconSpacing?: number;
  contentMaxWidth?: string;
};

export const InfoCard = ({
  icon: IconComponent,
  children,
  className,
  withBorder = false,
  onClick,
  sx,
  iconSpacing = 2,
  contentMaxWidth = '350px',
}: InfoCardProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }

    navigate('/gestao-de-habilidades');
  };

  return (
    <Card
      sx={[
        ({ palette }) => ({
          display: 'flex',
          alignItems: 'center',
          border: withBorder
            ? `1px solid ${palette.background.default}`
            : 'none',
          width: '100%',
          height: '100%',
        }),
        ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
      ]}
      className={className}
    >
      <CardActionArea
        onClick={handleClick}
        style={{ textDecoration: 'none', color: 'inherit', height: '100%' }}
      >
        <Stack direction="row" spacing={iconSpacing} alignItems="center" p={3}>
          <IconComponent sx={{ color: 'primary.dark' }} />
          <Stack maxWidth={contentMaxWidth} flex={1}>
            {children}
          </Stack>
        </Stack>
      </CardActionArea>
    </Card>
  );
};
